import React from "react";

// Recreates the gold smile arc from the Smiles of Loudoun logo
export default function SunDivider({ className = "" }) {
  return (
    <div
      className={`flex justify-center items-center ${className}`}
      data-testid="smile-arc-divider"
      aria-hidden="true"
    >
      <svg
        width="160"
        height="40"
        viewBox="0 0 160 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 4 C 2 4, 12 12, 18 10"
          stroke="var(--accent)"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M8 12 C 25 38, 135 38, 158 12"
          stroke="var(--accent)"
          strokeWidth="1.5"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
    </div>
  );
}
